import { Reveal } from "./Reveal";

export const SectionHeading = ({
  overline,
  title,
  description,
  onDark = false,
  align = "left",
  className = "",
  testId,
}) => {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <Reveal
      data-testid={testId}
      className={`flex max-w-2xl flex-col gap-4 ${alignCls} ${className}`}
    >
      {overline && (
        <span
          className={`text-xs md:text-sm uppercase tracking-[0.22em] font-semibold ${
            onDark ? "text-orange" : "text-royal"
          }`}
        >
          {overline}
        </span>
      )}
      <h2
        className={`font-heading text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight ${
          onDark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`text-lg md:text-xl ${onDark ? "text-white/70" : "text-navy/70"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
};
